const root = `td-resource/attach/`
const urls = {
  downloadById: root + 'download'
}

export const downloadById = id => {
  return $http.download(urls.downloadById, { ids: id })
}
export const preview = id => {
  return $http.preview(urls.downloadById, { ids: id })
}
export default {
  preview,
  downloadById
}
